// eslint-disable-file

import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Image from "gatsby-image";
import styles from "./bio.module.scss";

interface BioProps {
  showWrittenBy?: boolean;
  showDescription?: boolean;
}

const Bio: React.FC<BioProps> = ({
  showWrittenBy = true,
  showDescription = true
}) => {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author } = data.site.siteMetadata;

        return (
          <div className={styles.bio_container} style={{ marginBottom: 30 }}>
            <div className={styles.horizontal_center}>
              <Image
                fixed={data.avatar.childImageSharp.fixed}
                alt={author}
                className={styles.bio_image_style}
                imgStyle={{ borderRadius: `50%` }}
              />
            </div>
            <div className={styles.name}>
              {showWrittenBy ? "Written by" : null} {author}
            </div>
            {showDescription && (
              <div className={styles.bio_description}>
                Programmer, writer, cat-lover. I also like biking, hiking and
                chilling in my hammock near a river.
              </div>
            )}
          </div>
        );
      }}
    />
  );
};

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 75, height: 75) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`;

export default Bio;
